/**
 * global.constants.ts
 * @createdOn: 08-Oct-2022
 * @author: SmartChartsNXT
 * @description: Export different constants and ENUM for entire project scope.
 */

export const PUBLIC_SITE = 'https://www.smartchartsnxt.com';

export const PDF_LIB_SRC = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/1.5.3/jspdf.min.js';

export const MIME_TYPE = {
  'jpg': 'image/jpeg',
  'jpeg': 'image/jpeg',
  'png': 'image/png',
  'bmp': 'image/bmp',
  'gif': 'image/gif',
  'svg': 'image/svg+xml'
};
